import { jsPDF } from 'jspdf';

import { CuripodElement } from '../../components/SlideComponents/slateUtil';
import renderParagraph from './renderParagraph';
import { setPdfTextStyling } from './renderUtils';

type RenderBulletListProps = {
  pdf: jsPDF;
  bulletListElement: CuripodElement;
  x: number;
  y: number;
  width: number;
  scale: number;
};

const renderBulletList = async ({
  pdf,
  x,
  y,
  width,
  bulletListElement,
  scale,
}: RenderBulletListProps) => {
  const currentX = x;
  let currentY = y;
  if (!bulletListElement.children || !Array.isArray(bulletListElement.children))
    return { updatedY: currentY };
  setPdfTextStyling({
    pdf,
    color: '#000', //black
    bold: false,
    italic: false,
  });
  const bulletChar = '\u2022';
  const bulletWidth = pdf.getTextDimensions(bulletChar).w;
  const bulletedHeight = pdf.getTextDimensions(bulletChar).h;
  const bulletLeftPadding = bulletWidth;
  const bulletRightPadding = bulletWidth * 0.5;

  for (const eachListItem of bulletListElement.children as CuripodElement[]) {
    setPdfTextStyling({
      pdf,
      color: '#000', //black
      bold: false,
      italic: false,
    });
    pdf.text(bulletChar, currentX + bulletLeftPadding, currentY + bulletedHeight);

    const { updatedY } = await renderParagraph({
      pdf,
      x: currentX + bulletLeftPadding + bulletWidth + bulletRightPadding,
      y: currentY,
      width: width - (bulletLeftPadding + bulletWidth + bulletRightPadding),
      paraElement: eachListItem,
      scale,
    });
    currentY = updatedY;
  }

  return { updatedY: currentY };
};

export default renderBulletList;
